import { render, staticRenderFns } from "./PrivateInvitationsList.vue?vue&type=template&id=4a8d5de4&scoped=true&"
import script from "./PrivateInvitationsList.vue?vue&type=script&lang=ts&"
export * from "./PrivateInvitationsList.vue?vue&type=script&lang=ts&"
import style0 from "./PrivateInvitationsList.vue?vue&type=style&index=0&id=4a8d5de4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8d5de4",
  null
  
)

export default component.exports